<template>
  <div
    class="c-popover"
    v-show="value"
  >
    <slot />
    <div class="c-popover__menu">
      <div
        class="c-popover__menuitem"
        v-for="action in actions"
        :key="action.id || action.text"
        @click="onItemClick(action)"
      >
        <van-icon :name="action.icon" />
        <div class="c-popover__text">
          {{ action.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';

export default {
  name: 'CPopover',
  components: {
    vanIcon: Icon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit('input', false);
      this.$emit('select', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-popover {
  color: #323233;
  position: fixed;
  right: 20px;
  top: 20px;
  z-index: 999;
  .van-icon {
    font-size: 36px;
  }
  &__menu {
    background-color: #fff;
    // box-shadow: 0 2PX 12PX rgba(50, 50, 51, 0.12);
    border-radius: 8PX;
    overflow: hidden;
  }
  &__menuitem {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 128PX;
    height: 44PX;
    padding: 0 16PX;
    font-size: 14PX;
    line-height: 20PX;
    cursor: pointer;
    background: #fff;
    border-bottom: 1PX solid #ebedf0;
  }
  &__text {
    padding-left: 20px;
  }
  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 6PX;

    top: 0;
    border-top-width: 0;
    border-bottom-color: #fff;
    transform: translate(-50%,-100%);
    right: 20PX;
  }
}
</style>
